import { Context, createContext, Dispatch } from 'react'
import { IReducerContextProps, ReducerAction } from 'utility-tools/module/reducers'

import { TOverrideType } from 'utility-tools/module/types'
import { TFiscalLocationValidationDto } from 'nexchange-service/module/auth'

enum EditUserFlowStatus {
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
}

enum EditUserReducerAction {
    SET_FLOW_STATUS = 'SET_FLOW_STATUS',
    SET_USER_DATA = 'SET_USER_DATA',
    SET_IS_LOADING = 'SET_IS_LOADING',
}

type TUserData = {
    username: string
    phoneNumber: string
    email: string
    fiscalLocation: TFiscalLocationValidationDto | null
}

type TEditUserState = {
    isLoading: boolean
    flowStatus: EditUserFlowStatus
    userData: null | TUserData
}

const initialEditUserState = <TEditUserState>{
    isLoading: true,
    flowStatus: EditUserFlowStatus.PENDING,
    userData: null,
}

class SetEditUserFlowStatusAction extends ReducerAction<EditUserFlowStatus> {
    constructor(status: EditUserFlowStatus) {
        super(EditUserReducerAction.SET_FLOW_STATUS, status)
    }
}

class SetEditedUserDataAction extends ReducerAction<TUserData> {
    constructor(userData: TUserData) {
        super(EditUserReducerAction.SET_USER_DATA, userData)
    }
}

class SetEditingIsLoadingAction extends ReducerAction<boolean> {
    constructor(isLoading: boolean) {
        super(EditUserReducerAction.SET_IS_LOADING, isLoading)
    }
}

type TEditUserReducerAction =
    | SetEditUserFlowStatusAction
    | SetEditedUserDataAction
    | SetEditingIsLoadingAction

const editUserReducer = (
    state: TEditUserState = initialEditUserState,
    action: TEditUserReducerAction,
): TEditUserState => {
    const { type, payload } = action

    switch (type) {
        case EditUserReducerAction.SET_FLOW_STATUS: {
            return <TEditUserState>{
                ...state,
                flowStatus: payload,
            }
        }
        case EditUserReducerAction.SET_USER_DATA: {
            return <TEditUserState>{
                ...state,
                userData: payload,
            }
        }
        case EditUserReducerAction.SET_IS_LOADING: {
            return <TEditUserState>{
                ...state,
                isLoading: payload,
            }
        }
        default:
            return state
    }
}

type TEditUserContext = Context<
    TOverrideType<
        IReducerContextProps,
        {
            state: TEditUserState
            dispatchAction?: Dispatch<TEditUserReducerAction>
        }
    >
>

const EditUserContext = createContext({
    state: initialEditUserState,
}) as TEditUserContext

export {
    EditUserContext,
    editUserReducer,
    EditUserFlowStatus,
    initialEditUserState,
    SetEditUserFlowStatusAction,
    SetEditedUserDataAction,
    SetEditingIsLoadingAction,
}
